import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { DetailPageError } from '~/modules/errors/components/DetailPageError';
import { useLabel } from '~/modules/settings/api/queries/label';
import { SettingsPageHeader } from '~/modules/settings/components/SettingsPageHeader';
import { SETTINGS_ROUTES } from '~/modules/settings/config/routes';

import type { LabelFormSchema } from '../../components/LabelForm';
import { LabelForm } from '../../components/LabelForm';

export function EditLabelPage() {
  const { t } = useTranslation('settings');
  const { labelId } = useParams();

  const { isLoading, error, label } = useLabel(labelId || '');
  const labelValues = useMemo<LabelFormSchema | null>(
    () =>
      label
        ? ({
            labelName: label.name,
            weaLabelCode: label.weaLabelCode,
            usLabelCode: label.usLabelCode || '',
            dealOwner: label.dealOwner,
            dealRegionScope: label.dealRegionScope,
            wmiLabelCode: '',
            marketingCompany: label.marketingCompany || '',
            repertoireOwner: '',
            wbsElementNumber: '',
            dealId: label.dealId || '',
            scopeId: label.scopeId || '',
            dealScope: label.dealScope || '',
            profitCenter: label.profitCenter || '',
            pmo: label.pmo || '',
            gvlCode: '',
            presentationLabel: '',
            distributors: '',
          } as const)
        : null,
    [label],
  );

  if (isLoading) {
    return <section className="py-md">{t('loading')}</section>;
  }

  if (error || !label || !labelValues || !labelId) {
    return (
      <DetailPageError
        errorCode={error?.response?.status}
        fallbackRoute={{
          href: SETTINGS_ROUTES.ROOT,
          label: t('backToUserManagement'),
        }}
      />
    );
  }

  const onSubmit = (data: LabelFormSchema) => {
    console.log(data);
  };

  return (
    <article className="relative h-full">
      <SettingsPageHeader
        breadcrumbItems={[
          { to: SETTINGS_ROUTES.ROOT, label: 'title' },
          { to: SETTINGS_ROUTES.LABEL_LIST, label: 'labels' },
          { to: '', label: 'label.editLabel' },
        ]}
        title="label.editLabel"
      />
      <LabelForm onSubmit={onSubmit} values={labelValues} isEditing={true} />
    </article>
  );
}

EditLabelPage.displayName = 'EditLabelPage';
